import cookieOperation from './cookieOperation';

/**
 * 会话超时管理工具
 * 功能：监控用户活动，超过1小时无操作自动登出
 */
class SessionTimeout {
  constructor() {
    this.timeoutDuration =60 * 60 * 1000; // 1小时（毫秒）
    this.lastActivityTime = null;
    this.checkInterval = null;
    this.activityEvents = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart', 'click'];
    this.isInitialized = false;
    this.activityHandler = null; // 保存事件处理函数的引用
  }

  /**
   * 初始化会话超时监控
   */
  init() {
    if (this.isInitialized) {
      return;
    }

    // 检查是否有登录信息
    const accessToken = sessionStorage.getItem('access_token') || cookieOperation.cookie.get('access_token');
    if (!accessToken) {
      return;
    }

    // 获取或设置最后活动时间
    const savedTime = sessionStorage.getItem('lastActivityTime');
    if (savedTime) {
      this.lastActivityTime = parseInt(savedTime, 10);
    } else {
      this.updateActivityTime();
    }

    // 绑定用户活动事件
    this.bindActivityEvents();

    // 启动定时检查
    this.startCheck();

    this.isInitialized = true;
  }

  /**
   * 更新最后活动时间
   */
  updateActivityTime() {
    this.lastActivityTime = Date.now();
    sessionStorage.setItem('lastActivityTime', this.lastActivityTime.toString());
  }

  /**
   * 绑定用户活动事件监听器
   */
  bindActivityEvents() {
    const self = this;
    // 创建统一的事件处理函数
    this.activityHandler = () => {
      self.updateActivityTime();
    };
    
    // 为每个事件类型绑定处理函数
    this.activityEvents.forEach(event => {
      document.addEventListener(event, this.activityHandler, true);
    });
  }

  /**
   * 启动定时检查
   */
  startCheck() {
    // 清除之前的定时器
    if (this.checkInterval) {
      clearInterval(this.checkInterval);
    }

    // 每30秒检查一次
    this.checkInterval = setInterval(() => {
      this.checkTimeout();
    }, 30 * 1000);
  }

  /**
   * 检查是否超时
   */
  checkTimeout() {
    const accessToken = sessionStorage.getItem('access_token') || cookieOperation.cookie.get('access_token');
    
    // 如果没有登录信息，清除监控
    if (!accessToken) {
      this.destroy();
      return;
    }

    // 如果没有最后活动时间，更新它
    if (!this.lastActivityTime) {
      this.updateActivityTime();
      return;
    }

    // 计算空闲时间
    const idleTime = Date.now() - this.lastActivityTime;

    // 如果超过1小时，执行登出
    if (idleTime >= this.timeoutDuration) {
      this.logout();
    }
  }

  /**
   * 登出并跳转到登录页
   */
  logout() {
    // 清除定时器
    this.destroy();

    // 清除登录信息
    cookieOperation.cookie.delete('access_token');
    cookieOperation.cookie.delete('userName');
    cookieOperation.cookie.delete('userType');
    cookieOperation.cookie.delete('userDept');
    sessionStorage.clear();

    // 显示提示信息
    if (window.Vue && window.Vue.prototype.$message) {
      window.Vue.prototype.$message({
        message: '登录已超时，请重新登录',
        type: 'warning',
        duration: 3000
      });
    }

    // 跳转到登录页
    if (window.location.hash) {
      window.location.hash = '#/login';
    } else {
      window.location.href = '/lds/#/login';
    }
  }

  /**
   * 销毁会话超时监控
   */
  destroy() {
    // 清除定时器
    if (this.checkInterval) {
      clearInterval(this.checkInterval);
      this.checkInterval = null;
    }

    // 移除事件监听器
    if (this.activityHandler) {
      this.activityEvents.forEach(event => {
        document.removeEventListener(event, this.activityHandler, true);
      });
      this.activityHandler = null;
    }

    // 清除最后活动时间
    this.lastActivityTime = null;
    this.isInitialized = false;
  }

  /**
   * 重置会话（登录成功后调用）
   */
  reset() {
    this.destroy();
    this.init();
  }
}

// 创建单例
const sessionTimeout = new SessionTimeout();

export default sessionTimeout;




// WEBPACK FOOTER //
// ./src/common/js/sessionTimeout.js